import { Box, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

let entradaIn = '';
let salidaIn = '';
class CambioHorario extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            cambiosHorariosFuncionario: [],
            consulta: false,
            numeroNombre: [],
            horasEntradas: [],
            horasSalidas: [],
            modalActualizar: false,
            modalBorrar: false,

            busqueda: {
                numeroFuncionarioBusqueda: '',
            },

            cambios: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                mes: '',
                anio: '',
                desde: '',
                hasta: '',
                entrada: '',
                dedicacion: '',
                salida: '',
                codigo: 71,
            },

            cambioEditar: {
                idCambioHorario: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                mes: '',
                anio: '',
                desde: '',
                hasta: '',
                entrada: '',
                dedicacion: '',
                salida: '',
            },
        }
        this.manejarCambioNumFun = this.manejarCambioNumFun.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarEnvioMovimiento = this.manejarEnvioMovimiento.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.obtenerCal = this.obtenerCal.bind(this);
        this.manejarCambioEditar = this.manejarCambioEditar.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntradas: datosEntrada,
        });

        const fech = new Date();
        const ani = fech.getFullYear();
        this.setState(state => {
            const cambiosActualizadas = state.cambios;
            cambiosActualizadas['anio'] = String(ani);
            return{
                cambios: cambiosActualizadas,
            }
        });
    }

    render(){
        return (
            <>
                <Container>
                    <h3>Cambio de Horario</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <form className='formulario1'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionarioBusqueda' value={this.state.busqueda.numeroFuncionarioBusqueda} onChange={this.manejarCambioNumFun} type="number" /></Item>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                        <Table sx={{minWidth: 700}}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Número de Funcionario</StyledTableCell>
                                    <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                    <StyledTableCell>Mes</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell>Entrada</StyledTableCell>
                                    <StyledTableCell>Salida</StyledTableCell>
                                    <StyledTableCell>Horas Efectivas</StyledTableCell>
                                    {this.state.consulta ? <StyledTableCell></StyledTableCell> : null}
                                    {this.state.consulta ? <StyledTableCell></StyledTableCell> : null}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/*Acá va lo que venga de base de datos */}
                                {this.state.cambiosHorariosFuncionario.map((datosAg) => (
                                    <StyledTableRow key={datosAg.idCambioHorario}>
                                        <StyledTableCell>{datosAg.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{datosAg.nombreFuncionario}</StyledTableCell>
                                        {datosAg.mes === 1 ? <StyledTableCell>ENERO</StyledTableCell> : datosAg.mes === 2 ? <StyledTableCell>FEBRERO</StyledTableCell> : datosAg.mes === 3 ? <StyledTableCell>MARZO</StyledTableCell> : datosAg.mes === 4 ? <StyledTableCell>ABRIL</StyledTableCell> : datosAg.mes === 5 ? <StyledTableCell>MAYO</StyledTableCell>
                                        : datosAg.mes === 6 ? <StyledTableCell>JUNIO</StyledTableCell> : datosAg.mes === 7 ? <StyledTableCell>JULIO</StyledTableCell> : datosAg.mes === 8 ? <StyledTableCell>AGOSTO</StyledTableCell> : datosAg.mes === 9 ? <StyledTableCell>SETIEMBRE</StyledTableCell> : datosAg.mes === 10 ? <StyledTableCell>OCTUBRE</StyledTableCell>
                                        : datosAg.mes === 11 ? <StyledTableCell>NOVIEMBRE</StyledTableCell> : datosAg.mes === 12 ? <StyledTableCell>DICIEMBRE</StyledTableCell> : null}
                                        <StyledTableCell>{datosAg.anio}</StyledTableCell>
                                        <StyledTableCell>{ datosAg.desde.substring(8,10) + '/' + datosAg.desde.substring(5,7) + '/' + datosAg.desde.substring(0,4)}</StyledTableCell>
                                        <StyledTableCell>{ datosAg.hasta.substring(8,10) + '/' + datosAg.hasta.substring(5,7) + '/' + datosAg.hasta.substring(0,4)}</StyledTableCell>
                                        {this.state.horasEntradas.map((name) => {
                                        if(datosAg.entrada === name.idEntrada){
                                            entradaIn = name.descripcion;
                                        }})}
                                        <StyledTableCell>{entradaIn}</StyledTableCell>
                                        {this.state.horasEntradas.map((name) => {
                                        if(datosAg.salida === name.idEntrada){
                                            salidaIn = name.descripcion;
                                        }})}
                                        <StyledTableCell>{salidaIn}</StyledTableCell>
                                        <StyledTableCell>{datosAg.dedicacion}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarEdicion(datosAg)}>Editar</button></StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosAg)}>Borrar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                                {this.state.consulta ? null :
                                    <StyledTableRow>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.cambios.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell>{this.state.cambios.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.cambios.mes} onChange={this.manejarCambiosDatos}>
                                                <option value=''>MES</option>
                                                <option key={1} value={1}>ENERO</option>
                                                <option key={2} value={2}>FEBRERO</option>
                                                <option key={3} value={3}>MARZO</option>
                                                <option key={4} value={4}>ABRIL</option>
                                                <option key={5} value={5}>MAYO</option>
                                                <option key={6} value={6}>JUNIO</option>
                                                <option key={7} value={7}>JULIO</option>
                                                <option key={8} value={8}>AGOSTO</option>
                                                <option key={9} value={9}>SETIEMBRE</option>
                                                <option key={10} value={10}>OCTUBRE</option>
                                                <option key={11} value={11}>NOVIEMBRE</option>
                                                <option key={12} value={12}>DICIEMBRE</option>
                                            </select>
                                        </StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.cambios.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.cambios.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='hasta' value={this.state.cambios.hasta} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entrada' value={this.state.cambios.entrada} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>ENTRADA</option>
                                                    {this.state.horasEntradas.map((name) =>
                                                    <option
                                                    key={name.idEntrada}
                                                    value={name.idEntrada}
                                                    >{name.descripcion}
                                                </option>
                                                )}
                                            </select>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salida' value={this.state.cambios.salida} onChange={this.manejarCambiosDatos}>
                                                <option value={''}>SALIDA</option>
                                                    {this.state.horasEntradas.map((name) =>
                                                    <option
                                                    key={name.idEntrada}
                                                    value={name.idEntrada}
                                                    >{name.descripcion}
                                                </option>
                                                )}
                                            </select>
                                        </StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='dedicacion' value={this.state.cambios.dedicacion} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    </StyledTableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {this.state.consulta ? '' : <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioMovimiento}>Agregar</button>}
                    {this.state.consulta ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : ''}
                    <br/>
                    <br/>
                </Container>
                <Modal open={this.state.modalActualizar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                        <h3 style={{textAlign:'center'}}>Editar Movimiento</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={6}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>{this.state.cambioEditar.numeroFuncionario}</Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Nombre de Funcionario</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>{this.state.cambioEditar.nombreFuncionario}</Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Mes</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.cambioEditar.mes} onChange={this.manejarCambioEditar}>
                                            <option value=''>MES</option>
                                            <option key={1} value={1}>ENERO</option>
                                            <option key={2} value={2}>FEBRERO</option>
                                            <option key={3} value={3}>MARZO</option>
                                            <option key={4} value={4}>ABRIL</option>
                                            <option key={5} value={5}>MAYO</option>
                                            <option key={6} value={6}>JUNIO</option>
                                            <option key={7} value={7}>JULIO</option>
                                            <option key={8} value={8}>AGOSTO</option>
                                            <option key={9} value={9}>SETIEMBRE</option>
                                            <option key={10} value={10}>OCTUBRE</option>
                                            <option key={11} value={11}>NOVIEMBRE</option>
                                            <option key={12} value={12}>DICIEMBRE</option>
                                        </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Año</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.cambioEditar.anio} onChange={this.manejarCambioEditar} type="number" /></Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Desde</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='desde' value={this.state.cambioEditar.desde} onChange={this.manejarCambioEditar} type="date" /></Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Hasta</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='hasta' value={this.state.cambioEditar.hasta} onChange={this.manejarCambioEditar} type="date" /></Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Entrada</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='entrada' value={this.state.cambioEditar.entrada} onChange={this.manejarCambioEditar}>
                                            <option value={''}>ENTRADA</option>
                                                {this.state.horasEntradas.map((name) =>
                                                <option
                                                key={name.idEntrada}
                                                value={name.idEntrada}
                                                >{name.descripcion}
                                            </option>
                                            )}
                                        </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Salida</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='salida' value={this.state.cambioEditar.salida} onChange={this.manejarCambioEditar}>
                                            <option value={''}>SALIDA</option>
                                                {this.state.horasEntradas.map((name) =>
                                                <option
                                                key={name.idEntrada}
                                                value={name.idEntrada}
                                                >{name.descripcion}
                                            </option>
                                            )}
                                        </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Dedicación</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='dedicacion' value={this.state.cambioEditar.dedicacion} onChange={this.manejarCambioEditar} type="text" /></Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={2}>
                                    
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioModificar}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
                <Modal open={this.state.modalBorrar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                        <h3 style={{textAlign:'center'}}>¿Confirmar Baja Cambio de Horario?</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
            </>
        )//Final return
    }//Final render

    manejarCambioNumFun(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(this.state.busqueda.numeroFuncionarioBusqueda === ''){
            this.setState({
                errores: "DEBE INGRESAR UN NUMERO DE FUNCIONARIO!",
            });
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify(this.state.busqueda);

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_cambiosHorario.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            if(exito){
                if(exito.length !== 0){

                    this.setState({
                        consulta: true,
                        cambiosHorariosFuncionario: exito,
                    })
                }else{
                    this.setState({
                        consulta: false,
                        cambiosHorariosFuncionario: [],
                        errores: 'No existen movimientos para el número de funcionario ingresado!',
                    });
                }
            }
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const cambiosActualizado = state.cambios;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    cambiosActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    cambiosActualizado['nombreFuncionario'] = '';
                }
                });
            }
            cambiosActualizado[clave] = valor;
            return{
                cambios: cambiosActualizado,
            };
        })
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            cambiosHorariosFuncionario: [],
            errores: null,
            notificaciones: null,
        });
    }


    async manejarEnvioMovimiento(e){
        e.preventDefault();
        const fechaActual = new Date();
        const anio = fechaActual.getFullYear();
        const mes = fechaActual.getMonth() + 1;
        const dia = String(fechaActual.getDate()).padStart(2,'0');
        //Controlar el ingreso de todos los campos que faltan
        /*const anioIngresadoDesde = this.state.movimientos.desde.substring(0,4);
        const mesIngresadoDesde = this.state.movimientos.desde.substring(5,7);
        const diaIngresadoDesde = this.state.movimientos.desde.substring(8,10);

        const anioIngresadoHasta = this.state.movimientos.hasta.substring(0,4);
        const mesIngresadoHasta = this.state.movimientos.hasta.substring(5,7);
        const diaIngresadoHasta = this.state.movimientos.hasta.substring(8,10);*/

        if(this.state.cambios.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario!',
            });
        }else if(this.state.cambios.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido!',
            });
        }else if(this.state.cambios.mes === ''){
            this.setState({
                errores: 'Debe seleccionar un mes!',
            });
        }else if(this.state.cambios.anio === ''){
            this.setState({
                errores: 'Debe ingresar un año!',
            });
        }else if(this.state.cambios.anio.length !== 4){
            this.setState({
                errores: 'Debe ingresar un año con el formato AAAA!',
            });
        }else if(this.state.cambios.desde === ''){
            this.setState({
                errores: 'Debe ingresar la fecha DESDE!',
            });
        }else if(this.state.cambios.hasta === ''){
            this.setState({
                errores: 'Debe ingresar la fecha HASTA!',
            });
        }else if(this.state.cambios.entrada === ''){
            this.setState({
                errores: 'Debe seleccionar la hora de entrada!',
            });
        }else if(this.state.cambios.dedicacion === ''){
            this.setState({
                errores: 'Debe ingresar la dedicación!',
            });
        }else{
            const cargaUtil = JSON.stringify(this.state.cambios);
            //Voy a probar hacer los controles en la logica

            const control = await fetch(`${Constantes.RUTA_API}/guardar_cambioHorarios.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });

            //-----------------------------------------------------------------
            if(res === 'ok'){
                this.setState({
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    errores: null,
                    cambios: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        mes: '',
                        anio: '',
                        desde: '',
                        hasta: '',
                        entrada: '',
                        dedicacion: '',
                        salida: '',
                        codigo: 71,
                    },
                });
                //}
            }
            //------------------------------------------------------------------------
        }
    }

    manejarEdicion(dato){
        this.setState({
            modalActualizar: true,
            cambioEditar: dato,
            notificaciones: null,
        });
    }

    manejarBorrar(dato){
        this.setState({
            modalBorrar: true,
            cambioEditar: dato,
            notificaciones: null,
        });
    }

    async obtenerCal(e){
        const cargaUtil = JSON.stringify(this.state.busqueda);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_cambiosHorario.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            cambiosHorariosFuncionario: exito,
        });
    } 

    async manejarEnvioModificar(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify(this.state.cambioEditar);

        const respuesta = await fetch(`${Constantes.RUTA_API}/editar_cambioHorario.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito,
            modalActualizar: false,
        });
        if(exito === 'ok'){
            this.setState({
                notificaciones: 'Los datos fueron ingresados correctamente',
                modalActualizar: false,
                errores: null,
            });
        }else{
            this.setState(state => {
                const movEditarActualizado = state.movEditar;
    
                movEditarActualizado['dias'] = movEditarActualizado.diasAnterior;
                movEditarActualizado['minutos'] = movEditarActualizado.minutosAnterior;
                return {
                    movEditar: movEditarActualizado,
                }
            })
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.obtenerCal();
        this.setState({
            modalActualizar: false,
            modalBorrar: false,
        });
    }

    manejarCambioEditar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const cambioEditarActualizado = state.cambioEditar;

            cambioEditarActualizado[clave] = valor;
            return {
                cambioEditar: cambioEditarActualizado,
            }
        })
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify(this.state.cambioEditar);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_cambioHorario.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito){
            let contador = 0;
            const arr = this.state.cambiosHorariosFuncionario;
            arr.map((name) => {
                if(this.state.cambioEditar.idCambioHorario === name.idCambioHorario){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrar: false,
                cambiosHorariosFuncionario: arr,
            });
        }
    }

}

export default CambioHorario